import apiBase from "@/api/unversioned/apiBase";
import { type AxiosRequestConfig } from "axios";

const baseURL = `${import.meta.env.VITE_API_BASE_URL}/risk-data`;

const getAll = async (path: string, config?: AxiosRequestConfig) => {
  const url = `${baseURL}${path}`;
  return apiBase("get", url, config);
};

export default { getAll };
